/**
 * アプリ全体で共有する定数。
 * 音声関連の数値は Alibaba LiveTranslate の公式仕様に合わせてあり、勝手に変えてはいけない。
 */
/** Alibaba LiveTranslate が要求するサンプルレート。 */
export const SAMPLE_RATE = 16000;
/** モノラル固定。 */
export const CHANNEL_COUNT = 1;
/**
 * 1フレームあたりのバイト数(公式仕様)。
 * 16bit = 2バイト/サンプル なので 1600 バイト = 800 サンプル = 50ms 相当。
 */
export const FRAME_BYTES = 1600;
/** 1フレームあたりのサンプル数。 */
export const FRAME_SAMPLES = FRAME_BYTES / 2;
export const PROFILE_IDS = [
    'core',
    'machine-operation',
    'knitting-programming',
    'yarn-feeding',
    'needle-bed',
    'maintenance',
    'troubleshooting',
    'cixing-specific',
    'apparel-production',
];
/** 管理画面や設定画面で表示する日本語ラベル。 */
export const PROFILE_LABELS = {
    core: '基本用語',
    'machine-operation': '機械操作',
    'knitting-programming': '編成プログラム',
    'yarn-feeding': '給糸',
    'needle-bed': '針床・目移し',
    maintenance: '保守・点検',
    troubleshooting: 'トラブル対応',
    'cixing-specific': 'CIXING固有',
    'apparel-production': 'アパレル製造',
};
/** `core` は常に読み込まれるため、UI では選択解除できない。 */
export const ALWAYS_ON_PROFILE = 'core';
export function isProfileId(value) {
    return typeof value === 'string' && PROFILE_IDS.includes(value);
}
//# sourceMappingURL=constants.js.map